import { render, staticRenderFns } from "./SmsRegister.vue?vue&type=template&id=0b754bfd&scoped=true&"
import script from "./SmsRegister.vue?vue&type=script&lang=js&"
export * from "./SmsRegister.vue?vue&type=script&lang=js&"
import style0 from "./SmsRegister.vue?vue&type=style&index=0&id=0b754bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b754bfd",
  null
  
)

export default component.exports